import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { UserRoleValue } from "../../constants/field-values";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";

interface PrivateLinkProps {
  children: ReactElement;
  requiredRoles: Array<UserRoleValue>;
  path: string;
  onClick: (e: any) => void;
  className?: string;
}

const PrivateLink = (props: PrivateLinkProps): ReactElement => {
  const {
    children,
    requiredRoles,
    path,
    onClick,
    className = "inline-link",
  } = props;

  const { loggedUserValue } = useLoggedUser();
  const hasPermission = requiredRoles.includes(
    (loggedUserValue.role || "") as UserRoleValue
  );

  if (hasPermission) {
    return (
      <Link
        to={{
          pathname: path,
        }}
        className={className}
        rel="noopener"
        onClick={onClick}
      >
        {children}
      </Link>
    );
  } else {
    return (
      <div className={className}>
        {React.cloneElement(children, {
          className: `${children.props.className || ""} disabled`.trim(),
        })}
      </div>
    );
  }
};

export default PrivateLink;
